import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { useTranslation } from '@wix/fe-essentials/react';
import { groupBy } from 'lodash';
import { useMemo } from 'react';
export function useImageGroups(_ref) {
  let {
    images,
    pageId,
    itemType,
    altHandlers
  } = _ref;
  const {
    t
  } = useTranslation();
  const crossPageLabel = t('accessibility-wizard.verticals-drill-in.static-group-title');
  return useMemo(() => {
    const elementsByEntityId = groupBy(images, img => img.entityId ?? '');
    const groups = Object.entries(elementsByEntityId).map(_ref2 => {
      var _groupImages$;
      let [groupId, groupImages] = _ref2;
      const entityId = (_groupImages$ = groupImages[0]) == null ? void 0 : _groupImages$.entityId;
      const isStaticPage = itemType === ITEM_TYPES.STATIC_PAGE_V2;
      const groupName = !isStaticPage ? (altHandlers == null || altHandlers.getEntityName == null ? void 0 : altHandlers.getEntityName(entityId ?? '')) || crossPageLabel : '';
      return {
        id: groupId,
        images: groupImages,
        label: groupName
      };
    });
    const getGroupPriority = group => {
      if (group.id === pageId) {
        return Number.MAX_SAFE_INTEGER;
      }
      return group.images.reduce((max, img) => {
        const priority = (altHandlers == null || altHandlers.getEntityPriority == null ? void 0 : altHandlers.getEntityPriority(img.id)) ?? 0;
        return Math.max(max, priority);
      }, -Infinity);
    };
    groups.sort((a, b) => getGroupPriority(b) - getGroupPriority(a));
    return groups;
  }, [altHandlers, crossPageLabel, images, itemType, pageId]);
}
//# sourceMappingURL=use-image-groups.js.map